import { hasYesOrNo } from 'models/validate';
import { selectiveServicePattern } from 'constants/patterns';
import { ValidateJSModel } from 'forms/shared/types/validatejs';
import * as formTypes from 'constants/formTypes';
import { getSafeDateTime } from 'helpers/date';
import { MilitarySelectiveServiceModel } from './types';

const militarySelectiveServiceValidator: ValidateJSModel<MilitarySelectiveServiceModel> = {
  WasBornAfter: (value, attributes, attributeName, options) => {
    const safeBirthdate = getSafeDateTime(options?.applicantBirthdate).datetime;
    const selectiveServiceDate = new Date(1959, 11, 31);
    if (value?.value === 'Yes' && safeBirthdate && safeBirthdate.toJSDate() <= selectiveServiceDate) {
      return {
        hasValue: {
          validator: {
            inclusion: {
              within: ['No'],
              message: 'military.selective.error.birthdateBefore'
            }
          }
        }
      };
    }
    return { hasValue: { validator: hasYesOrNo } };
  },

  HasRegisteredNotApplicable: {},

  HasRegistered: (value, attributes) => {
    if (attributes?.WasBornAfter?.value === 'Yes'
      && attributes?.HasRegisteredNotApplicable?.applicable) {
      return {
        hasValue: { validator: hasYesOrNo },
      };
    }

    return {};
  },

  RegistrationNumber: (value, attributes) => {
    if (attributes?.HasRegistered?.value === 'Yes') {
      return {
        hasValue: {
          validator: {
            format: {
              pattern: selectiveServicePattern,
              message: 'error.military.selective.registrationNumber.pattern',
            },
          },
        },
      };
    }

    return {};
  },

  Explanation: (value, attributes, attributeName, options) => {
    if (attributes?.HasRegistered?.value === 'No'
      || (attributes?.HasRegisteredNotApplicable?.applicable === false && options?.formType !== formTypes.SF852013)) {
      return {
        hasValue: true,
      };
    }

    return {};
  },

  Comments: {},

  AnswerComments: {},

  RegistrationNumberComments: {},

  DNKComments: {},

  LegalExemptionComments: {},
};

export default militarySelectiveServiceValidator;
